import { createFileRoute } from "@tanstack/react-router";
import { SignInPage } from "../features/auth";
import { sanitizeRedirectPath } from "../features/auth/utils/redirect";
import i18n from "../lib/i18n";

export const Route = createFileRoute("/sign-in")({
  component: SignInPage,
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => {
    const redirect = sanitizeRedirectPath(search.redirect);
    return redirect ? { redirect } : {};
  },
  head: () => {
    const title = i18n.t("auth.meta.sign_in_title");
    const description = i18n.t("auth.meta.sign_in_description");
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { name: "robots", content: "noindex,nofollow" },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
    };
  },
});
